import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NbActionsModule,
  NbCardModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
  NbCheckboxModule,
  NbRadioModule,
  NbInputModule,
  NbDatepickerModule,

} from '@nebular/theme';
import { NbTooltipModule } from '@theme/components/tooltip/tooltip.module';

import { NbSecurityModule } from '@nebular/security';

import {
  FooterComponent,
  HeaderComponent,
  LayoutDirectionSwitcherComponent,
  SearchInputComponent,
  SwitcherComponent,
  DialogComponent,
  ButtonComponent,
  CheckboxComponent,
  InputTextComponent,
  RadioComponent,
  SelectComponent,
  TextareaComponent,
  ValidationComponent,
  ValidationMessageDirective,
  DatePickerComponent,
  DatePickerFilterComponent,
  StatusViewCellComponent,
  NavigationLinkCellComponent,
  FullTextSearchGridComponent,
  ToolTipComponent,
  ImageDialogComponent,

} from './components';

import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  MoneyFormatPipe,
  EnumDisplayPipe,
  TenantDateFormatPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import { DEFAULT_THEME } from './styles/theme.default';
import { Ng2SmartTableModule } from '@theme/components/grid/ng2-smart-table/ng2-smart-table.module';

import { GridComponent } from './components/grid/grid-form/grid.component';

import { NbMomentDateModule } from '@nebular/moment';
import { DragDropDirective } from './directives/drag-and-drop-image.directive';
import { NbInfiniteListDirective } from './directives/infinite-list.directive';
import { ConfirmDialogComponent } from './components/confirmation-dialog/confirm-dialog.component';
import { GGAutoCompleteComponent } from './google-map/auto-complete/auto-complete.component';
import { LaddaModule } from 'angular2-ladda';
import { DialogDeactiveComponent } from './components/dialog-deactive/dialog-deactive.component';
import { RouteFormDialogComponent } from './components/route-form-dialog/route-form-dialog.component';
import { AutocompleteComponent } from './components/input/autocomplete/autocomplete.component';
import { VehicleService } from '@app/@core/services/vehicle.service';
import { DriverService } from '@app/@core/services/driver.service';
import { RouteService } from '@app/@core/services/route.service';
import { AddCustomerToRouteDialogComponent } from './components/add-customer-to-route-dialog/add-customer-to-route-dialog.component';
import { FloatingScrollDirective } from './directives/floating-scroll.directive';
import { ReorderCellComponent } from './components/grid/components/reorder-cell/reorder-cell.component';
import { NotesCellComponent } from './components/grid/components/notes-cell/notes-cell.component';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { AddressComponent } from './components/address/address.component';
import { InputTextNestedComponent } from './components/input/input-text-nested/input-text-nested.component';
import { InputMaskDirective } from './directives/input-mask.directive';
import { PopUpImageCellComponent } from './components/grid/components/pop-up-image-cell/pop-up-image-cell.component';
import { DateTimeCellComponent } from './components/grid/components/date-time-cell/date-time-cell.component';
import { PdfDialogComponent } from './components/pdf-dialog/pdf-dialog.component';
import { CheckBoxCellComponent } from './components/grid/components/check-box-cell/check-box-cell.component';
import { CollapseExpandCardDirective } from './directives/collapse-expand-card.directive';
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';
import { SignatureDialogComponent } from './components/signature-dialog/signature-dialog.component';
import { DeGoogleMapComponent } from './google-map/de-google-map/de-google-map.component';
import { GoogleMapsModule } from '@angular/google-maps'; // Import module
import { GoogleService } from './google-map/services/google.service';
import { DeGoogleMapDirectionComponent } from './google-map/de-google-map-direction/de-google-map-direction.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';


const NB_MODULES = [

  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbCardModule,
  NbCheckboxModule,
  NbRadioModule,
  NbInputModule,
  NbDatepickerModule.forRoot(),
  NbMomentDateModule,
  Ng2SmartTableModule,
  NbTooltipModule,
  MatAutocompleteModule,
  LaddaModule.forRoot({
    style: 'zoom-in',
  }),
  GoogleMapsModule

];
const COMPONENTS = [
  SwitcherComponent,
  LayoutDirectionSwitcherComponent,
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  DialogComponent,
  ButtonComponent,
  CheckboxComponent,
  InputTextComponent,
  RadioComponent,
  SelectComponent,
  TextareaComponent,
  ValidationComponent,
  StatusViewCellComponent,
  PopUpImageCellComponent,
  NavigationLinkCellComponent,
  DateTimeCellComponent,
  ValidationMessageDirective,
  DatePickerComponent,
  GridComponent,
  ConfirmDialogComponent,
  DialogDeactiveComponent,
  DialogComponent,
  DatePickerFilterComponent,
  FullTextSearchGridComponent,
  ToolTipComponent,
  GGAutoCompleteComponent,
  AutocompleteComponent,
  RouteFormDialogComponent,
  ReorderCellComponent,
  NotesCellComponent,
  ImageDialogComponent,
  AddressComponent,
  InputTextNestedComponent,
  PdfDialogComponent,
  CheckBoxCellComponent,
  SignaturePadComponent,
  SignatureDialogComponent,
  DeGoogleMapComponent,
  DeGoogleMapDirectionComponent
];
const DIRECTIVES = [
  DragDropDirective,
  NbInfiniteListDirective,
  FloatingScrollDirective,
  PhoneMaskDirective,
  InputMaskDirective,
  CollapseExpandCardDirective
];

const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  MoneyFormatPipe,
  EnumDisplayPipe,
  TenantDateFormatPipe
];

const entryComponents = [
  StatusViewCellComponent,
  CheckBoxCellComponent,
  PopUpImageCellComponent,
  NavigationLinkCellComponent,
  ConfirmDialogComponent,
  DialogComponent,
  DialogDeactiveComponent,
  DatePickerFilterComponent,
  RouteFormDialogComponent,
  ToolTipComponent,
  AddCustomerToRouteDialogComponent,
  ReorderCellComponent,
  NotesCellComponent,
  DateTimeCellComponent,
  ImageDialogComponent,
  PdfDialogComponent,
  DeGoogleMapComponent,
  DeGoogleMapDirectionComponent
];

const SERVICES = [
  VehicleService,
  DriverService,
  RouteService,
  GoogleService
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ...NB_MODULES
  
  ],
  exports: [
    CommonModule,
    ...PIPES,
    ...COMPONENTS,
    ...DIRECTIVES,
  ],
  declarations: [
    ...COMPONENTS,
    ...PIPES,
    ...DIRECTIVES,
    RouteFormDialogComponent,
    AddCustomerToRouteDialogComponent,
    DeGoogleMapComponent,
    DeGoogleMapDirectionComponent
  ],
  providers: [SERVICES],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'default',
          },
          [DEFAULT_THEME],
        ).providers,
      ],
    };
  }
}
